import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TechEcosystem.css';
import { ROUTES } from '../../utils/routes';

const heroBg = process.env.PUBLIC_URL + '/images/ecosystem/whymsbnr.jpg';

/* ── Ecosystem data ── */
const IMG = process.env.PUBLIC_URL + '/images';



export default function TechEcosystem() {
  const [technologyEcosystemData, setTechnologyEcosystemData] = useState({
    technology_ecosystem: {},
    site_settings: {}
  });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/technology-ecosystem`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setTechnologyEcosystemData(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <>
      {/* ── Banner ── */}
      <section className="te-banner inner-page-banner" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="te-banner-overlay inner-page-banner-overlay" />
        <div className="container te-banner-inner inner-page-banner-inner">
          <h1 className="inner-page-banner-title">Technology Ecosystem</h1>
        </div>
      </section>

      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button type="button" className="inner-page-home" onClick={handleNavigateHome}>Home</button>
            <span className="inner-page-sep"><i className="bi bi-chevron-right" /></span>
            <span className="inner-page-current">Technology Ecosystem</span>
          </nav>
        </div>
      </div>

      {/* ── Ecosystem — shared-screen split layout ── */}
      <section className="te-ecosystem-section">

        {/* Section header */}
        <div className="container">
          <div className="te-section-header" data-aos="fade-up">
            {/* <span className="te-tag">Our Platforms</span> */}
            <h2 className="te-section-title">Technology Ecosystem</h2>
            <p className="te-section-sub">
              MS Technologies builds enterprise solutions aligned with proven business platforms, modern data architectures, and emerging digital ecosystems. Our focus is practical value today and readiness for what comes next.
            </p>
          </div>
        </div>

        {/* Split rows — no container, full-width halves */}
        <div className='container'>
          <div className="te-splits">
            <div className="te-split aos-init aos-animate" data-aos="fade-left">
              <div className="te-split-text">
                <div dangerouslySetInnerHTML={{ __html: technologyEcosystemData.technology_ecosystem.content_1 }} />
              </div>
              {/* ── Image panel ── */}
              <div className="te-split-visual">
                <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${technologyEcosystemData.technology_ecosystem.folder_path}/${technologyEcosystemData.technology_ecosystem.image_1}`} alt={technologyEcosystemData.technology_ecosystem.image_1} className="te-split-img" />
              </div>
            </div>
            <div className="te-split te-split--reverse aos-init aos-animate" data-aos="fade-right">
              <div className="te-split-text">
                <div dangerouslySetInnerHTML={{ __html: technologyEcosystemData.technology_ecosystem.content_2 }} />
              </div>
              {/* ── Image panel ── */}
              <div className="te-split-visual">
                <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${technologyEcosystemData.technology_ecosystem.folder_path}/${technologyEcosystemData.technology_ecosystem.image_2}`} alt={technologyEcosystemData.technology_ecosystem.image_2} className="te-split-img" />
              </div>
            </div>
            <div className="te-split aos-init aos-animate" data-aos="fade-left">
              <div className="te-split-text">
                <div dangerouslySetInnerHTML={{ __html: technologyEcosystemData.technology_ecosystem.content_3 }} />
              </div>
              {/* ── Image panel ── */}
              <div className="te-split-visual">
                <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${technologyEcosystemData.technology_ecosystem.folder_path}/${technologyEcosystemData.technology_ecosystem.image_3}`} alt={technologyEcosystemData.technology_ecosystem.image_3} className="te-split-img" />
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* ── Future Collaboration ── */}
      <section className="te-future-section">
        <div className="container">
          <div className="te-future-inner" data-aos="fade-up">
            <div className="te-future-left">
              <h2 className="te-future-title">Future Collaboration</h2>
              <p className="te-future-body">
                We continuously invest in skills, ecosystem understanding, and solution alignment so
                we are ready for future collaboration opportunities with leading enterprise technology
                providers.
              </p>

            </div>
            <div className="te-future-right" data-aos="fade-left">
              <div className="te-future-visual">
                <div className="te-fv-ring te-fv-ring-1" />
                <div className="te-fv-ring te-fv-ring-2" />
                <div className="te-fv-ring te-fv-ring-3" />
                <div className="te-fv-core">
                  <i className="bi bi-globe2" />
                  <span>Enterprise<br />Ready</span>
                </div>
                {[
                  { icon: 'bi-grid-3x3-gap-fill', label: 'SAP', angle: 0 },
                  { icon: 'bi-cpu-fill', label: 'AI', angle: 120 },
                  { icon: 'bi-diagram-3-fill', label: 'Web3', angle: 240 },
                ].map((node) => (
                  <div
                    key={node.label}
                    className="te-fv-node"
                    style={{ '--angle': `${node.angle}deg` }}
                  >
                    <i className={`bi ${node.icon}`} />
                    <span>{node.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ── Trademark Disclaimer ── */}
        <section className="te-trademark-section">
          <div className="container">
            <p className="te-trademark-text">
              <strong>Recommended trademark notice:</strong> SAP® is a registered trademark of SAP SE.
              Databricks® is a registered trademark of Databricks, Inc. References to these platforms
              indicate implementation experience, technical alignment, or ecosystem focus only and do
              not imply official partnership or endorsement unless explicitly stated.
            </p>
          </div>
        </section>
      </section>

      {/* ── CTA ── */}
      <section className="te-cta-section">
        <div className="container-fluid px-5">
          <div className="te-cta-inner">
            <div className="te-cta-text">
              <h2 className="te-cta-heading">Ready to align your technology strategy?</h2>
              <p className="te-cta-sub">Talk to an expert about SAP, AI, and digital transformation.</p>
            </div>
            <a href={`mailto:${technologyEcosystemData.site_settings.email}`} className="btn-te-cta">
              Talk to an Expert
            </a>
          </div>
        </div>
      </section>


    </>
  );
}
